// ═══════════════════════════════════════════════════════════════════
// M — Modale générique
// Utilisée par : Pointage, TaskForm, AdminUI, SecPrest, et scripts 6-9
// ═══════════════════════════════════════════════════════════════════
import React from 'react';
import { Ic } from './Ic.jsx'

export const M = ({ ch, onC, title, col = 'var(--ink)', wide = false }) => (
  <div className="mbk" onClick={onC}>
    <div className={`mbox${wide ? ' mboxw' : ''}`} onClick={e => e.stopPropagation()}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid var(--li)' }}>
        <h2 className="D" style={{ fontSize: 20, color: col }}>{title}</h2>
        <button onClick={onC} className="btn bgh sm"><Ic n="x" /></button>
      </div>
      <div style={{ padding: '18px 20px' }}>{ch}</div>
    </div>
  </div>
)
